<template>
  <el-dialog title="音檔播放" :visible.sync="innerVisible" append-to-body>
    <aplayer
      autoplay
      :music="{
        title: assetName,
        artist: ' ',
        src: audioSrc,
        pic: '/img/amrtf.jpg',
        theme: 'pic',
      }"
    />

    <template #footer class="dialog-footer">
      <el-button type="primary" @click="innerVisible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import Aplayer from "vue-aplayer";

export default {
  components: {
    Aplayer,
  },
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedItemId: {
      type: Number,
      default: null,
    },
    assetName: {
      type: String,
      default: " ",
    },
  },
  computed: {
    audioSrc() {
      const baseURL = process.env.VUE_APP_APIURL
        ? process.env.VUE_APP_APIURL
        : window.location.origin.replace("//admin.", "//api.") + "/";
      return `${baseURL}asset2/play/${this.selectedItemId}?token=${this.$store.state.auth.access_token}`;
    },
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      isLoading: false,
      formLabelWidth: "100px",
      form: {
        name: "",
      },
    };
  },
  created() {
    //if (this.innerVisible) {
    //}
  },
  methods: {},
};
</script>

<style></style>
